import { IoChevronBack, IoChevronForward } from 'react-icons/io5';

/**
 * Pagination Component
 * Renders the pagination controls.
 */
const Pagination = ({
  currentPage,
  totalPages,
  onPageChange,
  totalUsers,
  limit,
}) => {
  if (totalPages <= 1) return null;

  const startItem = (currentPage - 1) * limit + 1;
  const endItem = Math.min(currentPage * limit, totalUsers);

  return (
    <div className="mt-6 flex flex-col items-center justify-between text-zinc-400 sm:flex-row">
      <p className="mb-4 text-sm sm:mb-0">
        Showing <span className="font-semibold text-zinc-200">{startItem}</span>{' '}
        to <span className="font-semibold text-zinc-200">{endItem}</span> of{' '}
        <span className="font-semibold text-zinc-200">{totalUsers}</span>{' '}
        results
      </p>
      <div className="flex items-center space-x-2">
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className="rounded-lg p-2 transition-colors hover:bg-zinc-800 disabled:cursor-not-allowed disabled:opacity-50"
        >
          <IoChevronBack className="h-5 w-5" />
        </button>
        <span className="text-sm font-medium text-zinc-200">
          Page {currentPage} of {totalPages}
        </span>
        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className="rounded-lg p-2 transition-colors hover:bg-zinc-800 disabled:cursor-not-allowed disabled:opacity-50"
        >
          <IoChevronForward className="h-5 w-5" />
        </button>
      </div>
    </div>
  );
};

export default Pagination;
